import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { CampaignLetterReviewResponse } from '../../api-models';
import { CampaignLetterReview } from '../../types/campaigns.type';

export default class PostApproveCampaignInformation extends BaseAdapter<CampaignLetterReviewResponse> implements AdapterInterface {
  rawResponse: CampaignLetterReviewResponse;

  async adaptResponse(request: number): Promise<CampaignLetterReview> {
    await this.fetchApiResponse('/api/approve-campaign-information', HTTPMethod.Post, { campaign_communication_id: request });
    return {
      campaignName: this.rawResponse.campaign_name,
      numberOfRecipients: this.rawResponse.number_of_recipients,
      channel: this.rawResponse.channel,
      letterProofUrl: this.rawResponse.letter_proof_url,
      mailingGuid: this.rawResponse.mailing_guid,
    };
  }
}
